import {
    getDataMapper,
    mapField,
    isString,
    parseISODuration,
    isNil,
    safeJsonParse,
} from "@/shared";

const mapGoogleAccessTokenFromServer = getDataMapper({
    accessToken: mapField("access_token"),
    expiresIn: mapField("expires_in", Number),
    scope: mapField("scope"),
    tokenType: mapField("token_type"),
    created: mapField("created", Number),
});

export const mapSettingsFromServer = getDataMapper({
    id: mapField("id", Number),
    minRentTime: mapField(
        "min_rent_time",
        (duration) => {
            if (isNil(duration)) duration = "PT0S";

            return parseISODuration(duration);
        },
        { applyToNil: true }
    ),
    const: mapField("const"),
    notifyMail: mapField("notify_mail"),
    shouldNotifyShift: mapField("notify_shift"),
    shouldNotifyVk: mapField("notify_vk"),
    shouldSendReports: mapField("send_shift_report", Boolean),
    groupId: mapField("group_id", Number),
    needCalcBreaking: mapField("need_calc_breaking", Boolean),
    summarizeDeposit: mapField("summarize_deposit", Boolean),
    activeHumanBalance: mapField("active_human_balance", Number),
    activeClientVerify: mapField("active_client_verify", Number),
    currency: mapField("currency", {
        const: mapField("const"),
    }),
    currencyId: mapField("currency", (currency) => currency?.id),
    timezoneId: mapField("timezone", (timezone) => timezone?.id),
    stockOrderNumber: mapField("stock_order_number", Number),
    stockOrderFormat: mapField("stock_order_format"),
    repairOrderNumber: mapField("repair_order_number", Number),
    repairOrderFormat: mapField("repair_order_format"),
    firstEnter: mapField("first_enter", Boolean),
    hasUserToken: mapField("has_user_token", Boolean),
    isDefaultTypeLegalEntity: mapField("is_legal_entity", Boolean),
    notifyBeforeEndRent: mapField("notify_before_end_rent", Boolean),
    notifyBeforeEndRentMinutes: mapField(
        "notify_before_end_rent_minutes",
        (value) => {
            return value == null ? null : Number(value);
        }
    ),
    notifyBeforeStartRent: mapField("notify_before_start_rent", Boolean),
    notifyAfterEndRent: mapField("notify_after_end_rent", Boolean),
    shouldSendRentNotifications: mapField("system_notify_rent", Boolean),
    notifyChat: mapField("notify_chat", Boolean),
    shouldSendShiftNotifications: mapField("system_notify_shift", Boolean),
    shouldSendVkNotifications: mapField("system_notify_vk", Boolean),
    shouldSendWidgetNotifications: mapField("system_notify_widget", Boolean),
    shouldSendTariffNotifications: mapField("system_notify_tariff", Boolean),
    hasModuleDelivery: mapField("has_module_delivery", Boolean),
    hasModuleRepair: mapField("has_module_repair", Boolean),
    hasModuleStock: mapField("has_module_stock", Boolean),
    login: mapField("login"),
    googleAccessTokenJson: mapField("google_access_token_json", (value) => {
        const parsed = isString(value) ? safeJsonParse(value) : null;

        return parsed !== null ? mapGoogleAccessTokenFromServer(parsed) : null;
    }),
    googleCalendarId: mapField("google_calendar_id", Number),
    amoAppId: mapField("amo_app_id", Number),
    amoSecret: mapField("amo_secret"),
    amoAccessToken: mapField("amo_access_token"),
    amoRefreshToken: mapField("amo_refresh_token"),
    amoBaseDomain: mapField("amo_base_domain"),
    myCallsKey: mapField("my_calls_key"),
    myCallsUrl: mapField("my_calls_url"),
    myCallsUsername: mapField("my_calls_username"),
    zadarmaPhone: mapField("zadarma_phone"),
    zadarmaKey: mapField("zadarma_key"),
    zadarmaSecret: mapField("zadarma_secret"),
    smsDPassword: mapField("sms_d_password"),
    smsDLogin: mapField("sms_d_login"),
    zadarmaAtc: mapField("zadarma_atc"),
    myCallsStatus: mapField("my_calls_status", Number),
    smsDiscountActiveName: mapField("sms_discount_active_name"),
});
